import { render, staticRenderFns } from "./Captacao.vue?vue&type=template&id=8dfa74c0&"
import script from "./Captacao.vue?vue&type=script&lang=ts&"
export * from "./Captacao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports